import { render, staticRenderFns } from "./select-double.vue?vue&type=template&id=4e3f6fc8"
import script from "./select-double.vue?vue&type=script&lang=js"
export * from "./select-double.vue?vue&type=script&lang=js"
import style0 from "./select-double.vue?vue&type=style&index=0&id=4e3f6fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports